import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Nav/Navbar";
import Footer from "../components/Footer/Footer";
import Button from "../components/Button/Button";
import imgBook_1_30 from "./imgBook/1_30.png";
import imgBook_1_31 from "./imgBook/1_31.png";
import imgBook_1_32 from "./imgBook/1_32.png";
import imgBook_1_33 from "./imgBook/1_33.png";
import imgBook_1_34 from "./imgBook/1_34.png";
import imgBook_1_35 from "./imgBook/1_35.png";
import imgBook_1_36 from "./imgBook/1_36.png";
import imgBook_1_37 from "./imgBook/1_37.png";
import './book.css';


const lecture_1_8 = () => {
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Тема 1.8. Диагностические программы общего и специального назначения</title>
            </Helmet>
            <Navbar />
            <div className="main">
                <div className="main_item">
                    <h2 className="h2_main">Раздел 1. Организация технического обслуживания ЭВМ</h2>
                    <h3 className="h3_main">Тема 1.8. Диагностические программы общего и специального назначения</h3>
                    <Button link_left="/book/lecture_17" link_rigth="/book/questions_1" />
                    <div className="charter_book">
                        Для СВТ существует несколько видов диагностических
                        программ (рис. 1.30), которые позволяют выявлять причины неполадок, возникающих в компьютере. Во многих случаях такие программы могут выполнить основную работу по определению дефектного узла. Условно их можно разделить на несколько групп, представленных ниже в порядке усложнения программ и расширения их возможностей.
                        <div className="h3_main"><img className="img_main_media" src={imgBook_1_30} alt="" /></div>
                        <div className="h3_main"><b>Рис. 1.30.</b> Виды диагностических программ</div>
                        <ul>
                            <li><b>POST</b> (<b>Power-On Self Test</b> — «процедура самопроверки                                 при включении») — выполняется при каждом включении компьютера.</li>
                            <li><b>Диагностические программы производителей ПК</b>. Большинство производителей компьютеров (IBM, Compaq, Hewlett-Packard, Dell и т. д.) выпускают для своих систем специализированное диагностическое программное обеспечение, которое обычно содержит набор тестов, позволяющих тщательно проверить все компоненты компьютера.</li>
                            <li><b>Диагностические программы, поставляемые с периферийными устройствами</b>. Многие производители оборудования выпускают диагностические программы, предназначенные для проверки определенного устройства. Например, компания Adaptec выпускает такие программы для проверки работоспособности SCSI-адаптеров.</li>
                            <li><b>Диагностические программы операционных систем</b>. ОС Windows NT/2000/XP поставляются с несколькими диагностическими программами для проверки различных компонентов компьютера.</li>
                            <li><b>Диагностические программы общего назначения</b>. Такие программы, обеспечивающие тщательное тестирование любых PC-совместимых компьютеров, выпускают многие компании.</li>
                            </ul>
                            <h4 className="h3_main">Диагностические программы специального назначения</h4>
                            Когда в 1981 г. фирма IBM начала выпуск персональных компьютеров, в них были предусмотрены методы повышения надежности, которые ранее никогда не применялись.
                            
Имеется в виду программа POST и контроль четности памяти. При каждом включении компьютера автоматически выполняется проверка его основных компонентов — процессора, микросхемы ПЗУ (ROM), вспомогательных элементов
системной платы, оперативной памяти и основных периферийных устройств. Эти тесты выполняются быстро и не очень
тщательно по сравнению с тестами, выполняемыми диагностическими программами. При обнаружении неисправного
компонента выдается предупреждение или сообщение об
ошибке (неисправности).<br></br>
Некоторые производители сетевых плат, например SMC
и ЗСОМ, также предлагают пользователям диагностическое
программное обеспечение. С помощью этих программ можно
проверить интерфейс шины, память, установленную на плате, векторы прерываний, а также выполнить циклический
тест. Эти программы обычно можно найти на дискете или
компакт-диске, поставляемом вместе с устройством, либо на
сайте производителя.<br></br>
<div className="h3_main"><img className="img_main_media" src={imgBook_1_31} alt="" /></div>
                        <div className="h3_main"><b>Рис. 1.31.</b> Окно программы CPU-Z при тестировании процессора</div>
Многие типы диагностических программ предназначены
для определенных видов аппаратного обеспечения. Такие
программы поставляются производителями вместе с устройствами. Однако подавляющее большинство решений создается сторонними разработчиками. Например, небольшая
программа <b>CPU-Z</b> (рис. 1.31) сообщает следующие сведения
об установленном в компьютере процессоре: название, изготовитель, напряжение питания ядра, сведения о кэше, наборы поддерживаемых инструкций и др., причем в некоторых
случаях программа может определить, «разогнан» ли процессор или он работает на заводской частоте. Другая программа для тестирования процессора — <b>Atomic Cpu Test</b>
 способна протестировать АЛУ, FPU процессора, а также его
кэш во взаимодействии с оперативной памятью. Один из результатов работы этой программы — коэффициент умножения тактовой частоты процессора: на это число надо умножить тактовую частоту, чтобы узнать, какая тактовая частота понадобится другому процессору, чтобы показать такой
же результат. Кроме результатов теста, эта программа также
показывает спецификацию, производителя, модель, «степпинг», наборы инструкций и тактовую частоту процессора.<br></br>
<div className="h3_main"><img className="img_main_media" src={imgBook_1_32} alt="" /></div>
                        <div className="h3_main"><b>Рис. 1.32.</b> Окно программы CPU Burn-in</div>
Еще одна утилита <b>CPU Burn-in</b> (рис. 1.32) предназначена
для максимального разогрева процессора для его проверки
на стабильность работы и эффективность охлаждения. CPU
Burn-in нагружает процессор FPU-интенсивными операциями в течение заданного времени и при нахождении ошибок
немедленно информирует пользователя.
<div className="h3_main"><img className="img_main_media" src={imgBook_1_33} alt="" /></div>
                        <div className="h3_main"><b>Рис. 1.33.</b> Интерфейс работающей программы Memtest86+</div>

Для тестирования и поиска ошибок оперативной памяти
разработана программа <b>Memtest86+</b> (рис. 1.33). Для работы
этой программы необходимо создать загрузочную дискету и
производить загрузку компьютера только с нее, поскольку
программа занимает мизерный объем оперативной памяти.
Особо следует отметить, что она может работать как на 32-,
так и на 64-битных системах.

<div className="h3_main"><img className="img_main_media" src={imgBook_1_34} alt="" /></div>
                        <div className="h3_main"><b>Рис. 1.34.</b> Окно программы GPU-Z при тестировании видеокарты</div>
Для получения детальной информации о видеокарте на
базе чипсетов NVIDIA и ATI можно также воспользоваться
программой <b>GPU-Z</b> (рис. 1.34). Она позволяет просмотреть
данные о видеочипе, его «ревизии», количестве вертексных
и шейдерных процессоров, размере памяти, версии драйвера
и другие характеристики.

Среди множества утилит для тестирования и точной диагностики жестких дисков стоит отметить <b>MHDD</b> и <b>Victoria</b>.
Эти программные продукты не только поддерживают работу
с большим количеством накопителей от различных производителей, но и позволяют работать с ними на низком уровне
(через порты контроллера). Они выполняют быструю и точную дефектоскопию поверхности дисков, содержат около десятка тестов для механических частей накопителя, а также
позволяют уменьшить акустический шум, издаваемый при
работе винчестера.<br></br>

Из других особенностей программы MHDD можно выделить следующие:
<ul>
<li>скрытие дефектных секторов, а также оптимальный алгоритм исправления «soft»-bad секторов (с неправильным CRC);</li>
<li>возможность уничтожения всей информации на накопителе без возможности ее восстановления (это иногда требуется из соображений конфиденциальности);</li>
<li>работа с парольной системой накопителя (установка и снятие пароля);</li>
<li>моментальное разбиение нового винчестера на один логический диск на весь объем винчестера;</li>
<li>«разогрев» накопителя и его тестирование в экстремальных условиях;</li>
<li>просмотр заводских дефект-листов на некоторых накопителях;</li>
<li>пакетное тестирование нескольких накопителей.</li>
</ul>
К дополнительным «плюсам» программы Victoria (рис. 1.35) можно отнести:
<ul>
<li>автоопределение PCI ATA/SATA контроллеров по коду класса;</li>
<li>вывод полной технической информации о жестком диске;</li>
<li>возможность создания и записи образа диска;</li>
<li>проверку памяти и интерфейса HDD;</li>
<li>«бенчмарк»-функции;</li>
<li>обнаружение и скрытие дефектов путем переназначения секторов из резерва;</li>
<li>посекторное копирование произвольной области жесткого диска в файл с пропуском дефектных участков (это может быть полезно для спасения информации с поврежденного диска);</li>
<li>управление парольной защитой;</li>
<li>возможность работы не только с загрузочной дискеты, но и из-под Windows ХР;</li>
<li>встроенный файловый менеджер;</li>
<li>встроенную справочную систему</li>
</ul>
<div className="h3_main"><img className="img_main_media" src={imgBook_1_35} alt="" /></div>
                        <div className="h3_main"><b>Рис. 1.35.</b> Интерфейс работающей программы Victoria</div>
Популярный тест мониторов <b>Nokia Monitor Test</b> предназначен для проверки геометрии, фокусировки, контрастности, цветности и прочих параметров монитора. Он работает
без инсталляции; все тесты и настройки подробно описаны
в приложенной справке.<br></br>
Большое количество диагностических программ специального назначения разработано компанией Passmark:
<b>KeyboardTest</b> — для мыши и клавиатуры, <b>ModemTest</b> —
для аналоговых модемов, <b>BatteryMon</b> — для аккумуляторных батарей ноутбуков и т. д.

<h4 className="h3_main">Диагностические программы общего назначения</h4>
Рассмотренные ранее некоторые программы для диагностики ПК являются лишь малой частью своего семейства. Для
работы с некоторыми из них требуются определенные знания об устройствах; другие представляют информацию в не
очень удобном виде; эксперименты с настройками третьих
могут привести к отказу компьютера. Таким образом, на
долю обычных пользователей остается не такой уж большой
выбор диагностических программ. Да и процедура диагностики из-за различных критериев запуска тестов может затянуться, если приходится выполнять ее для всего компьютера. В этой ситуации на помощь приходят <b>диагностические
программы общего назначения</b>. С их помощью можно сравнительно быстро провести полную диагностику ЭВМ и выявить неисправный блок, чтобы затем провести более подробную его диагностику.<br></br>
Несмотря на ограниченность тестового функционала, диагностические программы общего назначения используются
гораздо чаще и соответственно более известны. Многие пользователи, чей стаж работы с компьютером превышает полтора года, знакомы с программами Lavalys Everest и SiSoft
Sandra. Менее известной является SIW (System Info for
Windows). Рассмотрим их возможности более детально.<br></br>
<b>Lavalys Everest</b> — это решение автоматизированного сетевого аудита и мониторинга для организаций любого масштаба, позволяющее получить в мельчайших подробностях
абсолютно всю информацию относительно всех имеющихся
комплектующих и установленных программных продуктов.
Кроме того, эта программа предназначена для диагностики
и анализа компьютера. С ее помощью можно протестировать
13 основных категорий, по которым производится анализ,
причем в каждой категории есть подразделы.<br></br>
<div className="h3_main"><img className="img_main_media" src={imgBook_1_36} alt="" /></div>
                        <div className="h3_main"><b>Рис. 1.36.</b> Окно программы SiSoft Sandra</div>
Основной конкурент предыдущего пакета — <b>SiSoft Sandra</b>
(рис. 1.36) — также позволяет получить подробную информацию об установленных компонентах ПК. Постоянное расширение базы тестов и поддерживаемых устройств, а также возможность «бенчмаркинга» делают этот набор диагностических утилит бесценной находкой для «оверклокеров» и
сборщиков компьютеров. Пользовательский интерфейс в последних версиях программы стал гораздо дружественнее,
что тоже способствует росту ее популярности.<br></br>
<div className="h3_main"><img className="img_main_media" src={imgBook_1_37} alt="" /></div>
                        <div className="h3_main"><b>Рис. 1.37.</b> Окно программы SIW</div>
Менее известна программа <b>SIW</b> (рис. 1.37). Она аналогична программе Lavalys Everest по своим функциональным
возможностям, но при этом распространяется бесплатно,
не требует установки и поэтому может быть размещена не
только на жестком диске, но и на любом сменном носителе,
в том числе на дискете. Интерфейс программы многоязычный; она работает под любой версией Windows, включая
64-битные.<br></br>
Для решения определенной части проблем приобретать
диагностическую программу нецелесообразно, поскольку
ПК можно протестировать встроенными в операционную
систему утилитами. Кроме имеющихся в составе Windows
нескольких диагностических программ, пользователь может воспользоваться услугами службы технической поддержки.
                      
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default lecture_1_8